import { render, staticRenderFns } from "./require.vue?vue&type=template&id=5c665c49&scoped=true"
import script from "./require.vue?vue&type=script&lang=js"
export * from "./require.vue?vue&type=script&lang=js"
import style0 from "./require.vue?vue&type=style&index=0&id=5c665c49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c665c49",
  null
  
)

export default component.exports